import { createApp } from 'vue'
import App from './App.vue'
import encryptionPlugin from './plugins/encryption'
import router from './router'

import '../src/assets/css/global.css'

const app = createApp(App)

app.use(router)
app.use(encryptionPlugin)

app.mount('#app')
